document.addEventListener("DOMContentLoaded", () => {
  const section      = document.getElementById("JapipackBillingSection");
  const toggle       = document.getElementById("japipack-billing-toggle");
  const formWrapper  = document.getElementById("japipack-billing-form");
  const errorMsg     = document.getElementById("japipack-error-msg");
  const regionSelect = document.getElementById("region_factura");
  const comunaSelect = document.getElementById("comuna_factura");
  const rutInput     = document.getElementById("rut_factura");

  // Formulario principal del carrito (donde se mandan los atributos)
  const cartForm = document.getElementById("cart");

  if (!section || !toggle || !formWrapper || !cartForm) return;

  const preRegion = section.dataset.region || "";
  const preComuna = section.dataset.comuna || "";

  const MENSAJE_CAMPOS = "Por favor completa todos los datos de facturación correctamente antes de continuar.";
  const MENSAJE_RUT = "El RUT no es válido. Revisa los números y el dígito verificador.";

  const mostrarError = (texto, tipo) => {
    if (!errorMsg) return;
    errorMsg.textContent = texto;
    errorMsg.dataset.tipo = tipo;
    errorMsg.style.display = "block";
  };

  const ocultarError = (tipo) => {
    if (!errorMsg) return;
    if (tipo && errorMsg.dataset.tipo !== tipo) return;
    errorMsg.textContent = "";
    errorMsg.dataset.tipo = "";
    errorMsg.style.display = "none";
  };

  // ---------------------------
  // 0. RUT: limpiar, validar dígito verificador y formatear
  // ---------------------------
  const limpiarRut = (valor) =>
    String(valor || "").replace(/[^0-9kK]/g, "").toUpperCase();

  const calcularDv = (cuerpo) => {
    let suma = 0;
    let multiplo = 2;
    for (let i = cuerpo.length - 1; i >= 0; i--) {
      suma += Number(cuerpo[i]) * multiplo;
      multiplo = multiplo === 7 ? 2 : multiplo + 1;
    }
    const resto = 11 - (suma % 11);
    if (resto === 11) return "0";
    if (resto === 10) return "K";
    return String(resto);
  };

  const rutValido = (valor) => {
    const limpio = limpiarRut(valor);
    if (!/^\d{7,8}[0-9K]$/.test(limpio)) return false;
    return calcularDv(limpio.slice(0, -1)) === limpio.slice(-1);
  };

  const formatearRut = (valor) => {
    const limpio = limpiarRut(valor);
    const cuerpo = limpio.slice(0, -1).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return cuerpo + "-" + limpio.slice(-1);
  };

  if (rutInput) {
    rutInput.addEventListener("blur", () => {
      const valor = rutInput.value.trim();
      if (!valor) {
        rutInput.classList.remove("is-invalid");
        ocultarError("rut");
        return;
      }
      if (rutValido(valor)) {
        rutInput.value = formatearRut(valor);
        rutInput.classList.remove("is-invalid");
        ocultarError("rut");
      } else {
        rutInput.classList.add("is-invalid");
        mostrarError(MENSAJE_RUT, "rut");
      }
    });
  }

  // ---------------------------
  // 1. Mostrar / ocultar formulario
  // ---------------------------
  const syncFormVisibility = () => {
    if (toggle.checked) {
      formWrapper.classList.add("active");
    } else {
      formWrapper.classList.remove("active");
      ocultarError();
    }
  };

  syncFormVisibility();
  toggle.addEventListener("change", syncFormVisibility);

  // ---------------------------
  // 2. Manejo dinámico de comunas
  // ---------------------------
  const regionData = {};

  if (regionSelect && comunaSelect) {
    document
      .querySelectorAll("#region_factura option[data-comunas]")
      .forEach(option => {
        regionData[option.value] = option.dataset.comunas.split(",");
      });

    const fillComunas = (regionValue, preselectComuna) => {
      comunaSelect.innerHTML =
        '<option value="">Seleccione una comuna</option>';

      const comunas = regionData[regionValue];

      if (comunas && comunas.length) {
        comunaSelect.disabled = false;
        comunas.forEach(comuna => {
          const clean = comuna.trim();
          const opt = document.createElement("option");
          opt.value = clean;
          opt.textContent = clean;
          comunaSelect.appendChild(opt);
        });

        if (preselectComuna) {
          comunaSelect.value = preselectComuna;
        }
      } else {
        comunaSelect.disabled = true;
      }
    };

    regionSelect.addEventListener("change", () => {
      fillComunas(regionSelect.value, "");
    });

    // Preseleccionar si vienen valores desde Liquid
    if (preRegion) {
      regionSelect.value = preRegion;
      fillComunas(preRegion, preComuna || "");
    }
  }

  // ---------------------------
  // 3. Validación antes de enviar el carrito
  // ---------------------------
  cartForm.addEventListener("submit", (event) => {
    // Si NO solicita factura: se vacían los campos. Shopify borra del carrito
    // los datos que recibe vacíos, y la casilla deja de reaparecer marcada.
    if (!toggle.checked) {
      formWrapper.querySelectorAll("[name]").forEach(el => {
        el.disabled = false;
        el.value = "";
      });
      return;
    }

    // Si SÍ solicita factura: validar todos los campos
    const fields = [
      "razon_social",
      "rut_factura",
      "giro_factura",
      "direccion_factura",
      "correo_factura",
      "region_factura",
      "comuna_factura",
    ];

    let valid = fields.every(id => {
      const el = document.getElementById(id);
      return el && el.value && el.value.trim();
    });

    const emailEl = document.getElementById("correo_factura");
    const email = emailEl && emailEl.value ? emailEl.value.trim() : "";
    if (!email.includes("@") || !email.includes(".")) {
      valid = false;
    }

    if (!valid) {
      event.preventDefault();
      mostrarError(MENSAJE_CAMPOS, "campos");
      return;
    }

    // RUT con dígito verificador correcto
    if (rutInput && !rutValido(rutInput.value)) {
      event.preventDefault();
      rutInput.classList.add("is-invalid");
      rutInput.focus();
      mostrarError(MENSAJE_RUT, "rut");
      return;
    }

    // Todo bien: se guarda el RUT con un solo formato y el carrito sigue al pago
    if (rutInput) {
      rutInput.value = formatearRut(rutInput.value);
    }
  });
});
